import styled from "styled-components";
import * as React from "react";
import { Row } from "security-app/components/common/FormBaseStyles";
import { Button } from "components/bootstrap";
import { useTranslation } from "react-i18next";
const ButtonsRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;
const DefinitionFormControls = ({
  action,
  activeStepIndex,
  onCancel,
  onOpenNextPage,
  onOpenPrevPage,
  onSubmit,
  steps
}) => {
  const { t } = useTranslation("enterprise_security_events");
  return /* @__PURE__ */ React.createElement(ButtonsRow, null, /* @__PURE__ */ React.createElement(Row, { $align: "center", $gap: "0.5rem" }, activeStepIndex > 0 && /* @__PURE__ */ React.createElement(Button, { onClick: onOpenPrevPage, disabled: activeStepIndex === 0 }, t("form_controls.previous")), /* @__PURE__ */ React.createElement(Button, { onClick: onCancel }, t("form_controls.cancel"))), /* @__PURE__ */ React.createElement(Row, { $align: "center", $gap: "0.5rem" }, activeStepIndex < steps.length - 1 ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Button, { onClick: onSubmit }, t("form_controls.save_changes")), /* @__PURE__ */ React.createElement(Button, { onClick: onOpenNextPage }, t("form_controls.next"))) : /* @__PURE__ */ React.createElement(Button, { bsStyle: "primary", onClick: onSubmit }, action === "edit" ? t("form_controls.update_event_definition") : t("form_controls.create_event_definition"))));
};
export default DefinitionFormControls;
